import { render, staticRenderFns } from "./SupplierManufacturingAuthenticity.vue?vue&type=template&id=5f7b02c6&scoped=true"
import script from "./SupplierManufacturingAuthenticity.vue?vue&type=script&lang=js"
export * from "./SupplierManufacturingAuthenticity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7b02c6",
  null
  
)

export default component.exports